import React, {type FC, useEffect} from 'react'
import {useGetAdaptiveStyle, Button, Table, Row, Cell, Text, isRankChanged} from 'uikit'
import {BigCupIcon} from 'uikit/Icons'
import {useAppDispatch, useAppSelector} from 'store'
import {hideModalThunk} from 'store/modal/thunk'
import {getEntriesThunk} from 'store/topcup/thunk'
import {getTranslates} from 'store/translates/selectors'
import {getEntries} from 'store/topcup/selectors'
import {adaptiveConfigModal} from 'src/common/components/GamePage/consts'
import {ModalWrap} from '../ModalWrap'
import styles from './TopCupModal.scss'

export const TopCupModal: FC<{}> = () => {
  const {style} = useGetAdaptiveStyle(adaptiveConfigModal)
  const dispatch = useAppDispatch()
  const translates = useAppSelector(getTranslates)
  const entries = useAppSelector(getEntries)
  const handleClose = () => dispatch(hideModalThunk(null))

  useEffect(() => {
    dispatch(getEntriesThunk())
  }, [])

  return (
    <ModalWrap classes={{modal: styles.wrap}} style={style}>
      <div className={styles.topbar}>
        <BigCupIcon />
        <Text type="title" color="pink">{translates.TOP}</Text>
        <BigCupIcon />
      </div>
      <div className={styles.entities}>
        <Table type="leaderboard">
          {entries.map((item, index) => (
            <Row isHighlighted={item.isCurrentUser} isDivider={isRankChanged(entries, index)}>
              <Cell width={50}><Text type='text' color='primary'>{item.rank}.</Text></Cell>
              <Cell width={50}><img src={item.midImgSrc} width="45" height="45" /></Cell>
              <Cell width={200}><Text type='text' color='primary'>{item.name}</Text></Cell>
              <Cell width={100}><Text type='text' color='primary'>{item.score}</Text></Cell>
            </Row>
          ))}
        </Table>
      </div>
      <Button onClick={handleClose}>{translates.CLOSE}</Button>
    </ModalWrap>
  )
}
